export const auditTypes = {"self-esteem":"Самоаудит", "common":"Обычный"}